import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';

import { useIntl } from 'react-intl';
import messages from './messages';

import { getStyles } from './styles';
import { Box, Button, CircularProgress, Divider, IconButton, MenuItem, Popover, Tooltip, Typography } from '@mui/material';
import { ReactSVG } from 'react-svg';
import { IconSvg } from '../../../utils/globalIcons';
import { ArrowForward, MoreVert } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { tostAlert } from '../../../utils/AlertToast';

import getAnalyticsAppsData from '../../../utils/ApiFunctions/AnalyticsAppsData';
import { useAppContext } from '../../../context/AppContext';
import LoadBar from '../../../utils/LoadBar';
import { setAnalyticsAppsState } from '../../../Redux/slice/dataSlice';
import { setAnalyticsAppsAdded } from '../../../Redux/slice/newDataSlice';
import AnalyticsApi from '../../../Api/Services/AmeyaBackend/AnalyticsToolApi';
import AiAppsApi from '../../../Api/Services/AppflyteBackend/AiAppsApi';
import { fetchAccountId, fetchSubscriberId, fetchSubscriptionId, fetchThirdPartyToken, fetchThirdPartyTokenProvider } from '../../../utils/GetAccountDetails';
import FilesApi from '../../../Api/Services/AppflyteBackend/FileServiceApi';
import { jwtDecode } from 'jwt-decode';
import LoadAppLogo from '../../../components/LoadAppLogo';
import { useCredit } from '../../../context/CreditContext';
import ChatBotLoader from '../../../components/ChatBotLoader';
import { AdvancedChatPreview, SimpleChatPreview } from '../Chatbot/ChatConfigs';
import { useCheckCredit } from '../../../utils';
import { ANALYTICS_S3_BUCKET_CHATBOT_LOGO, ANALYTICS_S3_BUCKET_FOLDER, ANALYTICS_S3_BUCKET_SCRIPT_FILE } from '../../../utils/constants';

let s3_foldername = ANALYTICS_S3_BUCKET_FOLDER
let s3_file_name = ANALYTICS_S3_BUCKET_SCRIPT_FILE
let s3_logo_name = ANALYTICS_S3_BUCKET_CHATBOT_LOGO
let bucket_name = window.__ENV__.S3_BUCKET_NAME

function AiApps() {
  const theme = useTheme();
  const styles = getStyles(theme);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const intl = useIntl();
  const { selectedProject, setAppDetails, ameyaChatBotAppDetails, handleAnalyticsSteps } = useAppContext();
  const analytics_apps = useSelector(state => state.all_data.analytics_apps)
  const analytics_app_added = useSelector(state => state.data_added.analytics_app_added)
  const isOutOfCredits = useCheckCredit();

  const [loading, setLoading] = useState(false);
  const [chatbotLoading, setChatbotLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [appList, setAppList] = useState([]);

  const deleteDatasetDetails = { appId: null, __auto_id__: null, appAnchorEl: null, logo: null }
  const [deleteAppData, setDeleteAppData] = useState(deleteDatasetDetails);

  const appData = [{
    "name": "Answering Bot",
    "value": "ai_bot",
    "description": "Connect your datasets and let answering bot understand your user’s questions and provide instant answers and offers help 24/7."
  }
    // {
    //   "name": "Live Boards",
    //   "value": "dashboards",
    //   "description": "Live boards deliver data intelligence that goes well beyond the dashboards of the past. Connect your datasets and build live boards with natural language."
    // }
  ]

  useEffect(() => {
    setAppDetails(ameyaChatBotAppDetails)
    getAllApps()
    //eslint-disable-next-line
  }, [analytics_app_added])

  const getAllApps = async () => {
    setLoading(true)
    try {
      if ((analytics_apps || [])?.length > 0 && analytics_app_added === false) {
        setAppList(analytics_apps)
      } else {
        const project_id = selectedProject?.payload?.__auto_id__ ?? null;
        const response = await getAnalyticsAppsData(project_id);
        dispatch(setAnalyticsAppsState(response))
        dispatch(setAnalyticsAppsAdded(false))
        setAppList(response)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const handleDeleteApp = async () => {
    try {
      setDeleteAppData({ ...deleteAppData, appAnchorEl: null });

      const confirmed = window.confirm(intl.formatMessage(messages.delete_check));
      if (!confirmed) return;

      setDataLoading(true);

      const analyticsResponse = await AnalyticsApi.deleteAiApp(deleteAppData.appId);

      if (analyticsResponse.status !== 200 && analyticsResponse.data?.message !== "App not found or already deleted") {
        tostAlert(intl.formatMessage(messages.delete_error), "error");
        return;
      }

      const deleteResponse = await AiAppsApi.deleteApp(deleteAppData.__auto_id__);

      if (deleteResponse.status !== 200) {
        tostAlert(intl.formatMessage(messages.delete_error), "error");
        return;
      }

      dispatch(setAnalyticsAppsAdded(true));
      tostAlert(intl.formatMessage(messages.delete_success), "success");

      const project_id = selectedProject?.payload?.__auto_id__;
      const subscriber_id = await fetchSubscriberId();
      const subscription_id = await fetchSubscriptionId();
      const app_id = deleteAppData.__auto_id__;

      const script_path = `${s3_foldername}/${s3_file_name}/${subscriber_id}/${subscription_id}/${project_id}/${app_id}`;
      const logo_path = `${s3_foldername}/${s3_logo_name}/${subscriber_id}/${subscription_id}/${project_id}/${app_id}`;

      FilesApi.deleteFolder(script_path).catch(console.error);
      FilesApi.deleteFolder(logo_path).catch(console.error);

    } catch (err) {
      console.error("Delete app failed:", err);
      tostAlert(intl.formatMessage(messages.delete_error), "error");
    } finally {
      setDeleteAppData(deleteDatasetDetails);
      setDataLoading(false);
    }
  };

  const loadChatBot = async (chatBotData, app_bot_type) => {
    try {
      handleAnalyticsSteps('analytics_app_test_status')
      const scriptId = "analytics-script";
      const existingScript = document.getElementById(scriptId);

      if (existingScript) {
        console.log("Removing existing analytics script...");
        existingScript.remove();
      }

      let newScript = null;
      if (app_bot_type === 'advanced_bot') {
        newScript = await AdvancedChatPreview(chatBotData);
      } else {
        newScript = await SimpleChatPreview(chatBotData);
      }

      const script = document.createElement("script");
      script.id = scriptId;
      script.type = "text/javascript";
      script.textContent = newScript;
      document.body.appendChild(script);

      return script;
    } catch (error) {
      console.error("Error loading chatbot:", error);
      return null;
    }
  };

  const checkProject = async () => {
    try {
      const project_id = selectedProject?.payload?.__auto_id__;
      const service_token = JSON.parse(localStorage.getItem('service-agent-user-token')) ?? null;
      if (service_token) {
        const token = jwtDecode(service_token);
        const token_project_id = token?.project_id ?? null;
        if (token_project_id === project_id) {
          return;
        } else {
          localStorage.removeItem("service-agent-user-token")
          localStorage.removeItem("agent-user-token")
          localStorage.removeItem("analytics_base_url")
        }
        return
      }
      return
    } catch (error) {
      console.log(error)
      return
    }
  }

  const handleConfigureApp = async (app_id) => {
    if (dataLoading || loading || !app_id || chatbotLoading) {
      return
    }

    if (isOutOfCredits) {
      tostAlert(intl.formatMessage(messages.credit_error), 'error')
      return
    }
    navigate(`/edit-ai-app/${app_id}`)
  }

  const handleAiAppLaunch = async (app_id) => {

    if (dataLoading || loading || !app_id) {
      return
    }

    if (isOutOfCredits) {
      tostAlert(intl.formatMessage(messages.credit_error), 'error')
      return
    }

    setChatbotLoading(true)
    try {

      await checkProject()
      const account_id = await fetchAccountId();
      const subscriber_id = await fetchSubscriberId();
      const subscription_id = await fetchSubscriptionId();
      const project_id = selectedProject?.payload?.__auto_id__
      const file_name = `${s3_foldername}/${s3_file_name}/${subscriber_id}/${subscription_id}/${project_id}/${app_id}.js`;

      const response = await FilesApi.getDownloadUrl(bucket_name, file_name)
      if (response.status === 200) {

        const logo_res_data = response?.data?.at(-1) ?? null;
        const logo_url = Object.values(logo_res_data)?.at(-1) ?? null;
        if (!logo_url) {
          tostAlert(intl.formatMessage(messages.lauch_error), 'warning');
        }

        const configData = await fetch(logo_url);
        const scriptText = await configData.text();
        const configMatch = scriptText.match(/const\s+chatbotConfig\s*=\s*(\{[\s\S]*?\})\s*;?\s*\/\/\s*END\s+chatbotConfig/);

        if (configMatch && configMatch[1]) {
          const chatbotConfig = JSON.parse(configMatch[1]) ?? {};
          const app_account_id = chatbotConfig?.APPFLYTE_ACCOUNT_CONFIGS?.account_id || account_id;
          const app_subscriber_id = chatbotConfig?.APPFLYTE_ACCOUNT_CONFIGS?.subscriber_id || subscriber_id;
          const app_subscription_id = chatbotConfig?.APPFLYTE_ACCOUNT_CONFIGS?.subscription_id || subscription_id;
          const app_project_id = chatbotConfig?.APPFLYTE_ACCOUNT_CONFIGS?.project_id || project_id;
          const app_schema_id = chatbotConfig?.APPFLYTE_ACCOUNT_CONFIGS?.schema_id || window.__ENV__.AMEYA_COLLECTIONS_SCHEMA_ID;

          const app_id = chatbotConfig?.APP_DETAILS?.app_id ?? '';
          const app_name = chatbotConfig?.APP_DETAILS?.app_name ?? '';
          const app_description = chatbotConfig?.APP_DETAILS?.app_description ?? '';
          const app_bot_type = chatbotConfig?.APP_DETAILS?.app_bot_type ?? 'simple_bot';
          const app_launch_icon = chatbotConfig?.APP_DETAILS?.app_launch_icon ?? 'app_launch_icon';
          const welcome_message = chatbotConfig?.WELCOME_MESSAGE ?? '';
          const feedback_status = chatbotConfig?.APP_DETAILS?.feedback_status ?? false;
          const feedback_url = chatbotConfig?.APP_DETAILS?.feedback_url ?? '';

          const app_logo_name = chatbotConfig?.APP_DETAILS?.app_logo_name ?? null;

          const datasets = chatbotConfig?.SOURCE_DETAILS?.datasets ?? [];
          const default_dataset = chatbotConfig?.SOURCE_DETAILS?.default_dataset ?? null;

          const authentication_config = chatbotConfig?.AUTHENTICATION_CONFIGS ?? {};
          const auth_type = authentication_config?.auth_type ?? 'no_auth';
          const service_agent_user_token_id = authentication_config?.service_agent_user_token_id ?? null;
          const service_agent_user_token = authentication_config?.service_agent_user_token ?? null;
          const llm_type = authentication_config?.llm_type ?? 'gemini';

          const appflyte_backend_base_url = chatbotConfig?.API_URL_CONFIGS?.appflyte_backend_base_url || window.__ENV__.APPFLYTE_BACKEND_URL;
          const analytics_base_url = chatbotConfig?.API_URL_CONFIGS?.analytics_base_url || window.__ENV__.ANALYTICS_SERVICE_URL;

          const chatStyleDetails = {
            font_family: chatbotConfig?.UI_CONFIGS?.font_family ?? "Inter",
            font_color: chatbotConfig?.UI_CONFIGS?.font_color ?? '#000000',
            background_color: chatbotConfig?.UI_CONFIGS?.background_color ?? '#000000',
            surface_color: chatbotConfig?.UI_CONFIGS?.surface_color ?? '#ffffff',
            surface_border: chatbotConfig?.UI_CONFIGS?.surface_border ?? '#ffffff',
            button_fill: chatbotConfig?.UI_CONFIGS?.button_fill ?? '#000000',
            button_text: chatbotConfig?.UI_CONFIGS?.button_text ?? '#000000',
            question_bubble_color: chatbotConfig?.UI_CONFIGS?.question_bubble_color ?? '#000000',
            question_bubble_font_color: chatbotConfig?.UI_CONFIGS?.question_bubble_font_color ?? '#ffffff',
            poweredby_logo_status: chatbotConfig?.UI_CONFIGS?.poweredby_logo_status ?? true
          }

          const chatBotData = {
            "WELCOME_MESSAGE": welcome_message,
            "APP_DETAILS": {
              "app_id": app_id,
              "app_name": app_name,
              "app_description": app_description,
              "app_bot_type": app_bot_type,
              "app_launch_icon": app_launch_icon,
              "app_logo_name": app_logo_name,
              "feedback_status": feedback_status,
              "feedback_url": feedback_url
            },
            "APPFLYTE_ACCOUNT_CONFIGS": {
              "account_id": app_account_id,
              "subscriber_id": app_subscriber_id,
              "subscription_id": app_subscription_id,
              "schema_id": app_schema_id,
              "project_id": app_project_id
            },
            "API_URL_CONFIGS": {
              "appflyte_backend_base_url": appflyte_backend_base_url,
              "analytics_base_url": analytics_base_url
            },
            "SOURCE_DETAILS": {
              "default_dataset": default_dataset,
              "datasets": datasets
            },
            "UI_CONFIGS": chatStyleDetails || {},
            "AUTHENTICATION_CONFIGS": {
              "auth_type": auth_type,
              "llm_type": llm_type,
              "service_agent_user_token_id": service_agent_user_token_id,
              "service_agent_user_token": service_agent_user_token
            },
          }

          const third_party_token = await fetchThirdPartyToken();
          const token_provider = await fetchThirdPartyTokenProvider()

          const script_load = await loadChatBot(chatBotData, app_bot_type);
          if (!script_load) {
            tostAlert(intl.formatMessage(messages.lauch_error), 'warning');
          } else {
            if (app_bot_type === 'advanced_bot') {

              setTimeout(() => {
                if (window.toggleChatbotPreview) {
                  if (auth_type === 'auth') {
                    window.toggleChatbotPreview(token_provider, third_party_token);
                  } else {
                    window.toggleChatbotPreview();
                  }
                } else {
                  tostAlert(intl.formatMessage(messages.lauch_error), 'warning');
                }
              }, 50);
            }

          }

          return
        }
      }
      tostAlert(intl.formatMessage(messages.lauch_error), 'warning');
    } catch (error) {
      console.log(error)
    } finally {
      setChatbotLoading(false)
    }
  }

  const handleGenerateAiApp = async () => {

    if (dataLoading || loading) {
      return
    }

    if (isOutOfCredits) {
      tostAlert(intl.formatMessage(messages.credit_error), 'error')
      return
    }

    navigate('/create-ai-app')
  }

  return (
    <Box sx={styles.mainContainer}>
      <Box sx={styles.cardContainer}>

        {(loading || dataLoading) && <LoadBar />}
        {chatbotLoading && <ChatBotLoader />}


        <Typography sx={{ fontSize: '16px', fontWeight: '600' }}>My AI Apps</Typography>
        {loading ?
          (<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '100px' }}>
            <CircularProgress />
          </Box>)
          :
          (appList || [])?.length === 0 && !loading ?
            (<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', marginTop: '100px' }}>
              <Typography sx={{ fontSize: '14px', fontWeight: '400' }}>
                No Apps Available
              </Typography>
            </Box>)
            :
            (<Box
              sx={{
                marginTop: '20px',
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                gap: '10px',
                flexWrap: 'wrap',
              }}
            >
              {appList?.map((item, index) => {
                const name = item?.payload?.name || '';
                const description = item?.payload?.description || '';
                const app_id = item?.payload?.app_id || null;
                const logo_path = item?.payload?.app_logo || null;

                return (
                  <Box
                    key={index}
                    sx={{
                      bgcolor: '#FFFFFF',
                      borderRadius: '15px',
                      border: '1px solid #DEDEDE',
                      width: '363px',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Box sx={{ padding: '20px', flexGrow: 1 }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                        <Box
                          sx={{
                            width: '124px',
                            height: '32px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            overflow: 'hidden',
                            '& img, & svg': {
                              height: '100%',
                              objectFit: 'contain',
                            },
                          }}
                        >
                          <LoadAppLogo logo_path={logo_path} />
                        </Box>


                        <IconButton
                          onClick={(e) => setDeleteAppData(prev => ({
                            ...prev,
                            appAnchorEl: e.currentTarget,
                            appId: app_id,
                            __auto_id__: item?.payload?.__auto_id__,
                            logo: item?.payload?.app_logo
                          }))}
                        >
                          <MoreVert />
                        </IconButton>
                      </Box>

                      <Box marginTop={'10px'} textAlign={'start'}>
                        <Tooltip title={name} arrow>
                          <Typography
                            sx={{
                              fontSize: '16px',
                              fontWeight: 600,
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              maxWidth: '280px',
                            }}
                          >
                            {name}
                          </Typography>
                        </Tooltip>

                        <Button
                          sx={{
                            marginTop: '7px',
                            width: '96px',
                            border: '1px solid #000000',
                            borderRadius: '10px',
                            color: '#000000',
                            cursor: 'auto'
                          }}
                        >
                          <Typography sx={{ fontSize: '9px', fontWeight: 400 }}>
                            {item?.payload?.type}
                          </Typography>
                        </Button>

                        <Tooltip title={description} arrow>
                          <Typography
                            sx={{
                              ...styles.paraText,
                              marginTop: '7px',
                              display: '-webkit-box',
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: 'vertical',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            {description}
                          </Typography>
                        </Tooltip>
                      </Box>
                    </Box>

                    <Divider />
                    <Box display={'flex'} alignItems={'center'}  >

                      <Box
                        sx={{
                          width: '50%', borderRight: "0.1px solid #0000001F",
                          "&:hover": {
                            backgroundColor: '#DEDEDE', color: '#0B51C5', textDecoration: 'underline',
                            borderBottomLeftRadius: '15px',
                            "& svg": { stroke: '#ffffff' }
                          }
                        }}
                        onClick={() => handleConfigureApp(app_id)}
                      >
                        <Box
                          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '10px', cursor: 'pointer' }}
                        >
                          <ReactSVG
                            src={IconSvg.configureIcon}
                            beforeInjection={(svg) => {
                              svg.setAttribute('style', 'width: 18px; height:18px; display: block;');
                            }}
                          />
                          <Typography sx={{ marginLeft: '5px', fontSize: '12px', fontWeight: '400', color: '#0B51C5' }}>Configure</Typography>
                        </Box>
                      </Box >
                      <Box
                        sx={{
                          width: '50%',
                          "&:hover": {
                            backgroundColor: '#DEDEDE', color: '#0B51C5', textDecoration: 'underline',
                            borderBottomRightRadius: '15px',
                            "& svg": { stroke: '#ffffff' }
                          }
                        }}
                        onClick={() => handleAiAppLaunch(app_id)}
                      >
                        <Box
                          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '10px', cursor: 'pointer' }}
                        >
                          <ReactSVG
                            src={IconSvg.launchAppIcon}
                            beforeInjection={(svg) => {
                              svg.setAttribute('style', 'width: 18px; height:18px; display: block;');
                            }}
                          />
                          <Typography sx={{ marginLeft: '5px', fontSize: '12px', fontWeight: '400', color: '#0B51C5' }}>
                            Launch App
                          </Typography>
                        </Box>
                      </Box>
                    </Box >
                  </Box >
                );
              })}
            </Box >)
        }

        {
          !loading &&
          <Box marginTop={'30px'}>
            <Typography sx={{ fontSize: '16px', fontWeight: '600' }}>AI App Generators</Typography>
            <Typography sx={{ fontSize: '14px', fontWeight: '400', marginTop: '7px' }}>
              Select an AI app generator to build and customise your AI apps with zero coding
            </Typography>

            <Box sx={{ marginTop: '20px', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: '10px' }}>
              {appData?.map((item, index) => (
                <Box key={index} sx={styles.appContainer}>
                  <ReactSVG
                    src={{
                      ai_bot: IconSvg.apibotIcon,
                      dashboards: IconSvg.dashboardIcon,
                    }[item.value]}
                    beforeInjection={(svg) => {
                      svg.setAttribute('style', 'width:48px; height:48px; display:block;');
                    }}
                  />
                  <Box marginTop={'20px'} textAlign={'start'}>
                    <Typography sx={{ fontSize: '16px', fontWeight: 600 }}>
                      {item.name}
                    </Typography>
                    <Typography sx={{ ...styles.paraText, marginTop: '5px' }}>
                      {item.description}
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Box
                      sx={{ display: 'flex', alignItems: 'center', gap: '2px' }}
                      onClick={handleGenerateAiApp}
                    >
                      <Typography sx={{ color: '#0B51C5', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}>
                        Generate AI App
                      </Typography>
                      <IconButton>
                        <ArrowForward sx={{ color: '#0B51C5', height: '18px', width: '18px' }} />
                      </IconButton>
                    </Box>
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        }
      </Box >

      <Popover
        open={Boolean(deleteAppData.appAnchorEl)}
        anchorEl={deleteAppData.appAnchorEl}
        onClose={() => setDeleteAppData({ ...deleteAppData, appAnchorEl: null, appId: null, __auto_id__: null })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        sx={{ borderRadius: '5px' }}
      >
        <Box minWidth={150}>
          <MenuItem onClick={handleDeleteApp}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ReactSVG src={IconSvg.deleteIcon} beforeInjection={(svg) => {
                svg.setAttribute('style', 'width: 18x; height: 18px;display: block;');
                svg.setAttribute('stroke', '#C30E2E');
              }} />
              <Typography sx={{ fontSize: '14px', fontWeight: '400', marginLeft: '10px' }}>Delete</Typography>
            </Box>
          </MenuItem>
        </Box>
      </Popover>

    </Box >
  )
}

export default AiApps;